/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFuelPrice.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/fuel-price";

export class AutogenModelFuelPrice<RowType extends ModelRow> extends Endpoint<RowType, RowFuelPriceFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFuelPrice extends ModelRow<RowFuelPriceFields> {
	constructor(values?: Partial<RowFuelPriceFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFuelPriceFields {
	average_price: number;
	california_price: number;
	cntrl_atlntc_price: number;
	company_id: string;
	east_coast_price: number;
	gulf_coast_price: number;
	lower_atlntc_price: number;
	midwest_price: number;
	new_england_price: number;
	price_date: Date;
	rocky_mtn_price: number;
	west_coast_less_california: number;
	west_coast_price: number;
}

